import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { PageHero } from '../components/ui/PageHero';
import { Container, Eyebrow, Heading } from '../components/ui/Section';
import { CtaBand } from '../components/ui/CtaBand';
import { OperationFlow } from '../components/features/OperationFlow';
import { IMAGES, SOLUTIONS } from '../data/solutions';
import { serviceJsonLd, useSeo } from '../utils/seo';
export function Solutions() {
  useSeo({
    title: 'Soluciones | Logística, Facility Management, HSE y tecnología — Rabemar',
    description: 'Seis unidades de negocio bajo una única gestión: Logística & Supply Chain, Transporte & Distribución, Control Tower, Facility Management, HSE y Sustentabilidad.',
    path: '/soluciones',
    image: IMAGES.warehouse,
    breadcrumbs: [{
      name: 'Inicio',
      path: '/'
    }, {
      name: 'Soluciones',
      path: '/soluciones'
    }],
    jsonLd: [serviceJsonLd('Servicios integrales para empresas', 'Logística, transporte, Control Tower, Facility Management, HSE, tecnología y sustentabilidad bajo una única gestión operativa.', '/soluciones')]
  });
  return <>
      <PageHero eyebrow="Soluciones" title={<>
            Toda la operación, bajo un mismo modelo de gestión.
          </>} lead="Rabemar integra recursos humanos, proveedores, tecnología, procesos, control y ejecución. Cada unidad funciona por separado o como parte de un ecosistema operativo coordinado." image={IMAGES.warehouse} imageAlt="Interior de un centro de distribución con racks de pallets y un autoelevador en operación" crumbs={[{
      name: 'Inicio',
      path: '/'
    }, {
      name: 'Soluciones',
      path: '/soluciones'
    }]} ctaLabel="Solicitar propuesta" data-id="element-805" data-mp="3a3p05uo2q2lp" />

      <section className="bg-white py-20 md:py-28" data-id="element-806" data-mp="23nwgf0bp0qze">
        <Container data-id="element-807" data-mp="23mlaouyot95n">
          <div className="divide-y divide-mist-200" data-id="element-808" data-mp="23m1qt8ph8aoz">
            {SOLUTIONS.map(solution => <article key={solution.slug} className="grid gap-8 py-12 first:pt-0 lg:grid-cols-[auto_1fr_1fr] lg:gap-12" data-id="element-809" data-mp="1vldm31hjywqr">
                <span className="font-display text-sm font-bold tabular-nums text-accent-500 lg:w-16" data-id="element-810" data-mp="25d07fqnluc78">{solution.code}</span>
                <div data-id="element-811" data-mp="20ddm0txmhpnc">
                  <h2 className="font-display text-3xl font-bold tracking-tight text-graphite-900" data-id="element-812" data-mp="20f866612ldqd">{solution.title}</h2>
                  <p className="mt-4 text-base leading-relaxed text-graphite-500" data-id="element-813" data-mp="1cokwpgbiag1p">{solution.description}</p>
                  <Link to={solution.to} className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-brand-700 transition-colors duration-150 hover:text-brand-600" data-id="element-814" data-mp="17rcc792vxzxa">
                    {solution.cta}
                    <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-815" data-mp="2y0chj1ckwrjn" />
                  </Link>
                </div>
                <div data-id="element-816" data-mp="2t4ouarhnq8gs">
                  <p className="text-xs font-semibold uppercase tracking-[0.14em] text-graphite-500" data-id="element-817" data-mp="30m3j57it0h2a">Alcance principal</p>
                  <ul className="mt-4 space-y-2" data-id="element-818" data-mp="35lpwri2jnzbm">
                    {solution.highlights.map(h => <li key={h} className="text-sm leading-relaxed text-graphite-500" data-id="element-819" data-mp="2rm70pnn0cefo">
                        · {h}
                      </li>)}
                  </ul>
                </div>
              </article>)}
          </div>
        </Container>
      </section>

      <section className="bg-graphite-900 py-20 md:py-28" data-id="element-820" data-mp="3obxutlrdzzky">
        <Container data-id="element-821" data-mp="3odin14q8b6fn">
          <div className="max-w-3xl" data-id="element-822" data-mp="3akj751mjba7k">
            <Eyebrow tone="dark" data-id="element-823" data-mp="3ajhyf3szqzt0">Operación de punta a punta</Eyebrow>
            <Heading as="h2" size="md" tone="dark" className="mt-5" data-id="element-824" data-mp="3elcv1uzz8p0g">
              Un solo hilo conductor entre la carga y el indicador.
            </Heading>
          </div>
          <div className="mt-10" data-id="element-825" data-mp="awrpwhqjd8z7">
            <OperationFlow data-id="element-826" data-mp="ax1lckuco8ca" />
          </div>
        </Container>
      </section>

      <CtaBand title="¿Qué parte de su operación quiere poner bajo control primero?" text="Podemos empezar por el área con mayor fricción y ampliar el alcance a medida que los indicadores lo justifiquen." primaryLabel="Analizar mi operación" location="soluciones-cta" data-id="element-827" data-mp="2jdkm9jn4541s" />
    </>;
}